<template>
  <span v-if="availability" :class="classes">
    <span>
      {{ name }}
    </span>
  </span>
</template>

<script>
import axios from "axios";

export default {
  name: "availability",

  props: ["availability"],

  data() {
    return {
      name: "",
    };
  },

  async created() {
    let response = await axios.get(`/markisen-konfigurator/availability/?availabilityId=${this.availability}`);
    let availability = response.data.availability;

    this.name = availability.names.find(name => name.lang === 'de').name;
  },

  computed: {
    classes() {
      return ["availability", "badge", "availability-" + this.availability];
    },
  },
};
</script>
